"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m6 10.74c-.12 3.09-2.67 5.64-5.76 5.76-3.01.12-5.56-1.99-6.12-4.82-.13-.61.36-1.18.98-1.18.47 0 .88.33.98.8.42 2.07 2.44 3.57 4.72 3.12 1.56-.3 2.82-1.56 3.12-3.12.5-2.56-1.45-4.8-3.92-4.8v1.79c0 .45-.54.67-.85.35l-2.8-2.79c-.2-.2-.2-.51 0-.71l2.79-2.79c.32-.31.86-.09.86.36V6.5c3.39 0 6.13 2.82 6 6.24"
}), 'ReplayCircleFilledRounded');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/icons-material/esm/ReplayCircleFilledRounded.js
// module id = 9891
// module chunks = 0